module.exports = __webpack_public_path__ + "static/media/traffic-event.11c51682.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traffic-event.svg
// module id = 420
// module chunks = 0